import React, { useEffect, useRef } from 'react';
import { useSelectFieldContext } from '../context/SelectFieldContext';
import styles from '../SelectField.module.scss';
// @ts-ignore
import classNames from 'classnames';

type SelectFieldOptionPropsType = {
  id: string;
  value: string | number;
  children: React.ReactNode;
  className?: string;
  selected?: boolean;
  onClick?: (value: any, event: React.MouseEvent<HTMLLIElement>) => void;
  ariaLabel?: string;
};

const SelectFieldOption = (props: SelectFieldOptionPropsType) => {
  const { value, onClick } = useSelectFieldContext();
  const listItemRef = useRef<HTMLLIElement>(null);

  const handleClick = (e: React.MouseEvent<HTMLLIElement>) => {
    if (props.onClick) {
      props.onClick(props.value, e);
    }

    if (onClick && listItemRef.current) {
      onClick(
        {
          value: props.value,
          name: listItemRef.current.innerText,
        },
        e
      );
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLLIElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleClick(e as unknown as React.MouseEvent<HTMLLIElement>);
    }
  };

  useEffect(() => {
    if (props.selected) {
      if (onClick && listItemRef.current) {
        onClick(
          {
            value: props.value,
            name: listItemRef.current.textContent,
          },
          listItemRef.current
        );
      }
    }
  }, [props.selected]);

  return (
    <li
      id={props.id}
      ref={listItemRef}
      className={classNames(
        styles.listItem,
        props.className,
        value && value === props.value && styles.listItemSelected
      )}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-label={props.ariaLabel}
      tabIndex={0}
    >
      {props.children}
    </li>
  );
};

export default React.memo(SelectFieldOption);
